import { Expense } from "../../expense/expense";

export class responseUpdateTargetBudget {
    expense: Expense = new Expense();
    constructor(data) {
        this.expense.onInit(data);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-update-target-budget.ts